export const hero = {
  title: 'Importação direta de equipamentos para academia',
  subtitle: 'Sob Consulta',
  button: 'Ver Produtos'
};

export const product = {
  specs: 'Specs',
  weight: 'Peso',
  volume: 'Volume',
  onRequest: 'Sob Consulta'
};

export const total = {
  label: 'VALOR TOTAL',
  onRequest: 'Sob Consulta'
};

export const delivery = {
  shipping: {
    label: 'PREVISÃO DE EMBARQUE',
    value: '30 Dias',
    description: 'Após recebimento do sinal'
  },
  delivery: {
    label: 'PREVISÃO DE ENTREGA',
    value: '60 Dias',
    description: 'Após embarque dos equipamentos'
  },
  packaging: {
    label: 'EMBALAGEM',
    value: 'Plywood',
    description: 'Caixa de madeira compensada'
  },
  warranty: {
    label: 'GARANTIA',
    value: '1 Ano',
    description: 'Peças de reposição gratuitas',
    note: '(não inclui frete de transporte das peças)'
  },
  manufacturer: {
    label: 'FABRICANTE',
    value: 'BRTW',
    link: 'Visitar site'
  }
};

export const financial = {
  title: 'VALOR TOTAL (BRL)',
  installment1: {
    title: 'Parcela 1 — Iniciar processo',
    description: '30% para iniciar produção'
  },
  installment2: {
    title: 'Parcela 2 — Liberação de embarque',
    description: 'Pagamento do produto para liberação'
  },
  installment3: {
    title: 'Parcela 3 — Chegada ao destino',
    description: 'Porto ou aeroporto'
  }
};

export const considerations = {
  title: 'Consideração da Proposta',
  validity: 'Validade da proposta: 15 dias',
  deadline: 'Prazo de envio: Equipamentos devem ser enviados dentro de 3 meses. Após este prazo, o contrato será considerado inválido.',
  observation: 'Observação: Por se tratar da importação direta de 10 equipamentos, qualquer substituição ou inclusão de novos itens implicará em recálculo dos valores.',
  assembly: 'Montagem e manutenção técnica: Não inclusas (responsabilidade do comprador).'
};

export const actions = {
  print: 'Imprimir',
  download: 'Baixar em PDF',
  whatsapp: 'Enviar por WhatsApp',
  email: 'Enviar por E-mail',
  whatsappText: 'Olá! Segue a proposta comercial da Moviis:',
  emailSubject: 'Proposta Comercial Moviis',
  emailBody: 'Olá! Segue a proposta comercial da Moviis:'
};

export const contact = {
  meeting: {
    title: 'Agendar uma Reunião',
    button: 'Agendar Agora'
  },
  email: {
    title: 'Fale Conosco',
    button: 'Enviar E-mail'
  }
};

export const footer = {
  description: 'Equipamentos profissionais para academia de alta performance.',
  equipment: {
    title: 'Equipamentos',
    cardio: 'Cardio',
    strength: 'Musculação',
    functional: 'Funcional'
  },
  info: {
    title: 'Informações',
    catalog: 'Catálogo',
    shipping: 'Embarque 30 dias',
    delivery: 'Entrega 60 dias',
    warranty: 'Garantia 1 ano'
  },
  contactInfo: {
    title: 'Contato',
    address: 'R. Voluntários da Pátria, n.º 2468, 6.º andar',
    zipcode: 'CEP 02402-000',
    phone: '(11) 3255-2877',
    email: 'lp@moviis.com.br',
    hours: 'Segunda a sexta-feira, 08:30 às 18:00 (GMT -03:00)'
  },
  copyright: '© 2026 Moviis. Todos os direitos reservados.',
  poweredBy: 'Powered by Readdy'
};

export default {
  'hero.title': hero.title,
  'hero.subtitle': hero.subtitle,
  'hero.button': hero.button,
  'product.specs': product.specs,
  'product.weight': product.weight,
  'product.volume': product.volume,
  'total.label': total.label
};